import { Layout } from "antd";

import { BaseSiderProps } from "./types";

const { Sider } = Layout;

const BaseSider = ({ ...props }: BaseSiderProps) => {
  return <Sider {...props} />;
};

export default BaseSider;
